/**
 * The sticky basket box (#crdBasketBox) and its fragment.
 *
 * Markup contract, in the page template so it survives the fragment exchange:
 *   <div id="crdBasketBox" x-data="stickyBasket({ parentClass: 'payment' })">
 *     {{ include_widget({ cl: "wStickyBasket", … }) }}
 *
 * Every action that changes the basket re-renders the whole widget on the server
 * and swaps it in here: prices, vouchers and totals are never calculated in the
 * browser. Alpine picks the new markup up on its own.
 *
 * mobileParent moves the whole box: the order step shows it between the item list
 * and the terms, which is inside the order form and not where the desktop column
 * stands, so the two places are different parents and no css rule reaches across.
 */
import { postAction } from '../shell/request.js';

/** Puts a freshly rendered widget into the box and shows the message it carries. */
export function applyStickyBasket(html) {
    const box = document.getElementById('crdBasketBox');

    box.innerHTML = html;
    showMessage(box);
}

export async function stickyBasketAction(fnc, body) {
    const box = document.getElementById('crdBasketBox');

    box.classList.add('is-loading');
    try {
        applyStickyBasket(await postAction(`/${URLSEGMENT}index.php?cl=wstickybasket&fnc=${fnc}`, body));
    } finally {
        box.classList.remove('is-loading');
    }
}

function showMessage(box) {
    box.querySelector('#errorsCoupon, #successCoupon, #successGiftcard')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

document.addEventListener('alpine:init', () => {
    Alpine.data('stickyBasket', ({ parentClass, mobileParent = '' }) => ({
        init() {
            showMessage(this.$el);

            if (mobileParent) {
                const box = this.$el;
                const desktopParent = box.parentElement;
                const desktopNextSibling = box.nextElementSibling;

                Alpine.effect(() => {
                    if (Alpine.store('viewport').isDesktop) {
                        desktopParent.insertBefore(box, desktopNextSibling);
                        return;
                    }
                    document.querySelector(mobileParent).append(box);
                });
            }
        },

        removeVoucher(voucherId) {
            return stickyBasketAction('removeVoucher', { voucherId, parentClass });
        },
    }));
});
